export const AvailabilityCalendarComponent = {
  templateUrl:
    './app/ajs/_shared/components/availability-calendar/availability-calendar.component.html',
  bindings: {
    booking: '<',
    bookingItem: '<',
    schedule: '=',
    onProductAddedToBookingItem: '&',
  },
  controller: AvailabilityCalendarController,
  controllerAs: 'vm',
};

AvailabilityCalendarController.$inject = ['ModalWindowConfirmService'];

function AvailabilityCalendarController(ModalWindowConfirmService) {
  const vm = this;

  // public methods
  // -----------------------
  vm.selectCalendarDay = function (day) {
    // if (!day.isAvailable || day.tax_price === 0) return; // why 0 is incorrect ??
    if (!day.isAvailable) return;

    let confirmCallback = () => vm.onProductAddedToBookingItem({ dateSelected: day });

    if (vm.bookingItem.id) {
      let cancelCallback = () => {
        return;
      };

      let modalParams = {
        title: 'UPDATE_BOOKING_ITEM', // CONFIRM_CHANGES
        body: 'UPDATE_BOOKING_ITEM_WARNING',
        mode: 'danger',
        requireConfirmation: true,
      };

      if (vm.bookingItem.based_on_service_items) {
        modalParams.body = 'UPDATE_BOOKING_ITEM_SERVICE_ITEMS_WARNING';
      }

      ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);

      return;
    }

    confirmCallback();
  };

  // vm.$onInit = function() {};
}
